module.exports = __webpack_public_path__ + "img/upgrade-img-2.9de7e22c.png";